import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { queryKeyMap } from "@/features/query-client";

export const useLenderResponseOptimisticallyUpdate = () => {
  const queryClient = useQueryClient();

  const { id } = useParams();

  const optimisticallyUpdateLenderResponse = () => {
    if (id)
      queryClient.invalidateQueries({
        queryKey: queryKeyMap.getLenderApplication(Number(id)),
      });
    queryClient.invalidateQueries({
      queryKey: queryKeyMap.getLenderApplicationsCounts,
    });
  };

  return optimisticallyUpdateLenderResponse;
};
